import { PhoneInput, PhoneType } from '../../../../../utils/classes/graphql'
import { getContactOptions } from '../utils'
import { OwnInfoContactWrapper } from './own-info-contact-wrapper'

const newPhone: PhoneInput = {
  id: null,
  ensisijainen: false,
  poisto: 0,
  puhelinnumero: '',
  tyyppi: PhoneType.Gsm
}

export const Phones = () => {
  const sectionTranslationId = 'phoneNumbers'
  return (
    <OwnInfoContactWrapper
      name="yhteystiedot.puhelinnumerot"
      keyPostfix="phone"
      sectionTranslationId={sectionTranslationId}
      newContactObject={newPhone}
      contactInfoProps={{
        contactTypeOptions: getContactOptions(
          Object.values(PhoneType),
          sectionTranslationId
        ),
        contactTypePostfix: '.phoneNumberType',
        contactValuePostfix: '.puhelinnumero'
      }}
      gridProps={{ md: 8 }}
    />
  )
}
